import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

const host = process.env.REACT_APP_API_HOST;
const base = `${host}/${apiConstants.SOURCING}`;
const req = `${host}/${apiConstants.QUOTE_REQUIREMENTS}`;
const data = async (p) => (await p).data;

// Staff: transport lanes, the desk's sourcing analysis, vendor behaviour,
// sourcing runs, and the requisitions ("asks") that go out to vendors.
export const listLanes = () => data(axios.get(`${base}/lanes`));
export const saveLane = (lane) => (lane.id ? axios.put(`${base}/lanes/${lane.id}`, lane) : axios.post(`${base}/lanes`, lane));
export const deleteLane = (id) => axios.delete(`${base}/lanes/${id}`);

export const sourcingAnalysis = (number) => data(axios.get(`${base}/requirements/${number}/analysis`));
export const vendorStats = (vendorId) => data(axios.get(`${base}/vendors/${vendorId}/stats`));
export const productVendors = (productId) => data(axios.get(`${base}/products/${productId}/vendors`));

export const listRuns = (params = {}) => data(axios.get(`${base}/runs`, { params }));
export const getRun = (id) => data(axios.get(`${base}/runs/${id}`));
export const createRun = (body) => axios.post(`${base}/runs`, body);
export const setRunStatus = (id, status) => axios.put(`${base}/runs/${id}/status`, { status });
export const listRunRequisitions = (id) => data(axios.get(`${base}/runs/${id}/requisitions`));
export const draftRunRequisitions = (id, vendorIds) => axios.post(`${base}/runs/${id}/requisitions`, vendorIds ? { vendorIds } : {});

export const listRequisitions = (number) => data(axios.get(`${req}/${number}/requisitions`));
export const draftRequisitions = (number, vendorIds) => axios.post(`${req}/${number}/requisitions`, vendorIds ? { vendorIds } : {});
